import EditBase from "../EditBase"
import { cartesians2lonlats, lonlats2cartesians } from "../../utils/CoordinateUtil.js"
class EditRectangleP extends EditBase {

    constructor(options) {
        super(options);
    }

    checkHeightPoint() {
        return false;
    }

    initKeyPoint() {
        var edit_positions = this.plot.attrPlot["edit_positions"]; //拿到关键点数组
        var keyPos = [edit_positions[0], edit_positions[2]];
        var e_pos = [];
        for (let i = 0; i < keyPos.length; i++) {
            var entity = this.createEnity();
            var point = this.createPoint(this.getDefaultStyle("point_Nor"));
            entity.show = false;
            entity.position = keyPos[i];
            entity.point = point;
            this.viewer.entities.add(entity);
            this.entities.push(entity);
            entity.attrPlot = {
                e_index: i*2,
                editGuid: this.editGuid,
                edit_keyFlag: true
            };
            e_pos.push(entity);
        }
        this.plot.attrPlot["edit_keyPos"] = e_pos; //实体
    }

    rotationAll(position) {
        var $this = this;
        var center = this.plot.attrPlot['center_cartesian3'];
        var PA = this.plot.attrPlot['startPoint'];
        var angle = this.getAngleCenterPointDir(center, PA, position);
        if (isNaN(angle)) {
            return;
        }
        let theta = angle * (180 / Math.PI);
        var newPos = this.getRotateCenterPoint(center, PA, theta);
        this.rotationPos.position.setValue(newPos); //更新旋转点
        var positions = this.plot.attrPlot["edit_positions"];
        var positions_copy = this.plot.attrPlot["edit_positions_copy"]
        for (let i = 0; i < positions_copy.length; i++) {
            var p = positions_copy[i];
            var newPos = this.getRotateCenterPoint(center, p, theta);
            positions[i] = newPos;
            if (i == 0) {
                $this.plot.attrPlot["edit_keyPos"][0].position.setValue(newPos);
            }
            if (i == 2) {
                $this.plot.attrPlot["edit_keyPos"][1].position.setValue(newPos);
            }

        }
    }

    initProperty() {
        var $this = this;
        var hierarchyProperty = new $this.Cesium.CallbackProperty(function () {
            var lonlats = cartesians2lonlats($this.plot.attrPlot["edit_positions"]);
            var p_B = [lonlats[2][0], lonlats[0][1], lonlats[0][2]];
            var p_D = [lonlats[0][0], lonlats[2][1], lonlats[2][2]];
            var cartesians = $this.getRectangle($this.plot.attrPlot["edit_positions"]);
    
            //$this.plot.attrPlot["edit_positions"]= cartesians;
            return new $this.Cesium.PolygonHierarchy([cartesians[0],cartesians[1],cartesians[3],cartesians[2],cartesians[0]]);
            //return $this.rotationPos ? new $this.Cesium.PolygonHierarchy($this.plot.attrPlot["edit_positions"]) : new $this.Cesium.PolygonHierarchy(cartesians);
        }, false);
        this.plot.polygon.hierarchy = hierarchyProperty;
    }

    leftDown(evt) {
        this.reset(); //拾取开始
        let pick = this.viewer.scene.pick(evt.position);
        var entity = this.getPickEnity(pick);
        if (entity && entity.attrPlot && entity.attrPlot["edit_keyFlag"] && entity.attrPlot["editGuid"] == this.editGuid) {
            this.pickPos = entity;
            this.lockCamera();//锁定相机
        }

        if (entity && entity.attrPlot && entity.attrPlot["edit_centerFlag"] && entity.attrPlot["editGuid"] == this.editGuid) {
            this.centerPos = entity;
            this.lockCamera();//锁定相机
        }
        if (entity && entity.attrPlot && entity.attrPlot["edit_rotationFlag"] && entity.attrPlot["editGuid"] == this.editGuid) {
            this.rotationPos = entity;
            this.plot.attrPlot['startPoint'] = entity.position.getValue();
            this.cloneKeyPos();
            this.lockCamera();//锁定相机
            this.plot.attrPlot['startRotation'] = this.plot.polygon.stRotation || 0;
        }
        if (entity && entity.attrPlot && entity.attrPlot["edit_heightFlag"] && entity.attrPlot["editGuid"] == this.editGuid) {
            this.heightPos = entity;
            this.lockCamera();//锁定相机
        }
    }

    rotationAll(position) {
        var PA = this.plot.attrPlot['startPoint'];
        var center = this.plot.attrPlot['center_cartesian3'];
        var startRotation = this.plot.attrPlot['startRotation'];
        var angle = this.getAngleCenterPointDir(center, position, PA) + startRotation;
        if (isNaN(angle)) {
            return;
        }
        let theta = angle * (180 / Math.PI);
        this.plot.polygon.stRotation = -angle;
        var newPos = this.getRotateCenterPoint(center, PA, -theta);
        this.rotationPos.position.setValue(newPos); //更新旋转点

        // var positions = this.plot.attrPlot["edit_positions"];
        // var positions_copy = this.plot.attrPlot["edit_positions_copy"]
        // for (let i = 0; i < positions_copy.length; i++) {
        //     var p = positions_copy[i];
        //     var newPos = this.getRotateCenterPoint(center, p, -theta);
        //     //positions[i] = newPos;
        //     if (i == 0) {
        //         this.plot.attrPlot["edit_keyPos"][0].position.setValue(newPos);
        //     }
        //     if (i == 2) {
        //         this.plot.attrPlot["edit_keyPos"][1].position.setValue(newPos);
        //     }
        // }
    }
}

export default EditRectangleP;